export default __webpack_public_path__ + "static/home-c7ca2ba79da64dba9417a9e0fcd1a70b.png";